'use strict';

var util = angular.module('gymsystem.util');

util.factory('productCategoryService', ['$rootScope', function($rootScope) {
    var self = {
        getAll: function() {
            return $rootScope.waitFor(['webshopcategories']);
        },
        getAsList: function(option) {
            option = option || {};
            return self.getAll().then(function(categories) {
                var result = [];

                function getChildren(pid) {
                    return categories.filter(function(c) {
                        if(option.active && c.removed) {return false;}
                        return c.parent_id === pid;
                    }).sort(function(a, b) {
                        if(a.order < b.order) {return -1;}
                        if(a.order > b.order) {return 1;}
                        return 0;
                    });
                }

                function pushChildren(pid, level) {
                    getChildren(pid).forEach(function(c) {
                        c.name = c.name.replaceAll(String.fromCharCode(3866), '');
                        for(var i=0;i<level;i++) {
                            c.name = String.fromCharCode(3866) + ' ' + c.name;
                        }
                        result.push(c);
                        pushChildren(c.id, level+1);
                    });
                }

                pushChildren(null, 0);
                return result;
            });
        },
        makeSelectField: function(option) {
            option = option || {};

            var result = [];
            var callbacks = [];
            var hasModulePermission;
            var defaultTitle = 'Checkout category';
            var labelClass = '';
            if ($rootScope.hasFlag('flag-unified-sales-category')) {
                if (option.webshop) {
                    hasModulePermission = $rootScope.hasModule('WebShop') || $rootScope.hasModule('Checkout');
                } else {
                    hasModulePermission = $rootScope.hasModule('Checkout');
                    defaultTitle = 'Checkout category (legacy)';
                    labelClass = 'legacy-field-label';
                }
            } else {
                hasModulePermission = $rootScope.hasModule(option.webshop ? 'WebShop' : 'Checkout');
            }
            if (hasModulePermission) {
                self.getAsList({active: true}).then(function(categories) {
                    result = categories.map(function(c, index) {
                        c.autoIndex = index;
                        return c;
                    });
                    callbacks.forEach(function(fn) {fn(result);});
                    callbacks = null;
                });
            }

            return {
                name: option.name || 'product_category_id',
                title: option.title || defaultTitle,
                required: option.required ? !!option.required : false,
                type: option.multiple ? 'multiselect' : 'select',
                options: function() {return result;},
                orderPredicate: 'autoIndex',
                placeholder: option.placeholder,
                useId: true,
                labelClass: labelClass,
                visible: function() {
                    if (!result.length || !hasModulePermission) { return false; }
                    if (option.visible && !option.visible()) { return false; }
                    return true;
                }
            };
        },
        makeWebshopSelectField: function(option) {
            option = option || {};
            option.name = option.name || 'product_webshop_category_id';
            if (!option.title) {
                if ($rootScope.hasFlag('flag-unified-sales-category')) {
                    option.title = 'Sales category';
                } else {
                    option.title = 'WebShop category';
                }
            }
            option.required = true;
            option.webshop = true;
            return self.makeSelectField(option);
        }
    };
    return self;
}]);
